import script from "./SizeTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./SizeTag.vue?vue&type=script&setup=true&lang=ts"

import "./SizeTag.vue?vue&type=style&index=0&id=30b8c3b2&scoped=true&lang=less"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b8c3b2"]])

export default __exports__